module.exports = "/assets/3e183f255d339f6784a4a6a1f18e47b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KB.png
// module id = 2663
// module chunks = 0